module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst progressKey = model.progressKey || ''\nlet symbol = config.symbols.before || ''\nlet progressStepFound = false\n%><div><%\nfor(const [key, element] of Object.entries(config.entities)){\nconst clazzes = ['element']\nif(key === progressKey){\nprogressStepFound = true\nsymbol = config.symbols.highlight\nclazzes.push('highlight')\n} else if(progressStepFound){\nsymbol = config.symbols.after\n} else {\nclazzes.push('highlight')\n}\n%><div class=\"<%- clazzes.join(' ') %>\">\n<section class=\"content default\">\n<div class=\"left\">\n<div class=\"title\"><%= element.titleKey || '' %></div>\n<div class=\"subTitle\"><%= element.subTitleKey || '' %></div>\n</div><%\nif(symbol){\n%><div class=\"right\">\n<div class=\"icon\"><i class=\"<%- symbol %>\"></i></div>\n</div><%\n}\n%>\n</section>\n</div>\n<% } %>\n</div>"
  , __filename = "components/templates/core/progress/progress.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const progressKey = model.progressKey || ''
let symbol = config.symbols.before || ''
let progressStepFound = false

    ; __line = 5
    ; __append("<div>")
    ; 
for(const [key, element] of Object.entries(config.entities)){
const clazzes = ['element']
if(key === progressKey){
progressStepFound = true
symbol = config.symbols.highlight
clazzes.push('highlight')
} else if(progressStepFound){
symbol = config.symbols.after
} else {
clazzes.push('highlight')
}

    ; __line = 17
    ; __append("<div class=\"")
    ; __append( clazzes.join(' ') )
    ; __append("\">\n<section class=\"content default\">\n<div class=\"left\">\n<div class=\"title\">")
    ; __line = 20
    ; __append(escapeFn( element.titleKey || '' ))
    ; __append("</div>\n<div class=\"subTitle\">")
    ; __line = 21
    ; __append(escapeFn( element.subTitleKey || '' ))
    ; __append("</div>\n</div>")
    ; __line = 22
    ; 
if(symbol){

    ; __line = 24
    ; __append("<div class=\"right\">\n<div class=\"icon\"><i class=\"")
    ; __line = 25
    ; __append( symbol )
    ; __append("\"></i></div>\n</div>")
    ; __line = 26
    ; 
}

    ; __line = 28
    ; __append("\n</section>\n</div>\n")
    ; __line = 31
    ;  } 
    ; __append("\n</div>")
    ; __line = 32
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/progress/progress.ejs

}